<template>
  <div>
    <!-- -----------COMEÇO DO FORMULARIO DE BUSCA DE CHECKLIST------------ -->
    <vs-card class="mb-6">
      <form role="form" @submit.stop.prevent="buscar">
        <vs-row vs-w="12">
          <vs-col
            class="mb-3"
            vs-justify="flex-start"
            vs-align="center"
            vs-lg="6"
            vs-sm="6"
            vs-xs="12"
          >
            <label id="DateLabel">Data Inicial</label>
            <datepicker
              :format="'dd/MM/yyyy'"
              placeholder="DD/MM/YYYY"
              v-model="formFiltro.dataInicial"
            ></datepicker>
          </vs-col>
          <vs-col
            class="mb-3"
            vs-justify="flex-start"
            vs-align="center"
            vs-lg="6"
            vs-sm="6"
            vs-xs="12"
          >
            <label id="DateLabel">Data Final</label>
            <datepicker
              :format="'dd/MM/yyyy'"
              placeholder="DD/MM/YYYY"
              v-model="formFiltro.dataFinal"
            ></datepicker>
          </vs-col>
          <vs-col class="mb-3" vs-lg="4" vs-sm="6" vs-xs="12">
            <label>Status</label>
            <v-select
              :options="status"
              name="Status"
              id="Status"
              v-model="formFiltro.status"
            ></v-select>
          </vs-col>
          <vs-col
            class="mb-3"
            vs-type="flex"
            vs-justify="flex-start"
            vs-align="center"
            vs-lg="4"
            vs-sm="6"
            vs-xs="12"
          >
            <vs-input
              v-mask="'AAA-#XX#'"
              class="w-full"
              name="Placa"
              label="Placa"
              v-model="formFiltro.placa"
            />
          </vs-col>
          <vs-col
            class="mb-3"
            vs-type="flex"
            vs-justify="flex-start"
            vs-align="center"
            vs-lg="4"
            vs-sm="6"
            vs-xs="12"
          >
            <vs-input
              class="w-full"
              name="Nome do Prospect"
              label="Nome do Propoect"
              v-model="formFiltro.nome"
            />
          </vs-col>
        </vs-row>
        <vs-row vs-w="12"> </vs-row>
      </form>
    </vs-card>
    <div slot="footer" style="margin-top: -3%">
      <br style="clear: both" />
      <vs-row vs-justify="flex-end">
        <vs-button
          color="success"
          type="filled"
          icon-pack="feather"
          icon="icon-search"
          class="mr-3 mb-2"
          @click="buscar"
          >Buscar</vs-button
        >
        <vs-button
          @click="limparFiltros"
          color="danger"
          type="gradient"
          icon-pack="feather"
          icon="icon-trash-2"
        ></vs-button>
      </vs-row>
    </div>
    <!-- -----------FIM DO FORMULARIO DE BUSCA DE CHECKLIST------------ -->
  </div>
</template>
<script>
import Datepicker from 'vuejs-datepicker';
import vSelect from 'vue-select';

export default {
  data() {
    const formFiltro = {
      dataInicial: this.dataInicio(),
      dataFinal: new Date(),
      status: null,
      nome: null,
      placa: null,
    };
    const status = [
      { label: 'Não Convertidas', code: 'Não Convertida' },
      { label: 'Convertidas', code: 'Convertida' },
    ];
    return {
      formFiltro,
      status,
    };
  },
  methods: {
    buscar() {
      this.$emit('filtrosSelecionados', this.formFiltro);
    },
    limparFiltros() {
      this.formFiltro = {
        responsavel: null,
        dataInicial: this.dataInicio(),
        dataFinal: new Date(),
        motivo: null,
        nome: null,
        placa: null,
      };
    },
    dataInicio() {
      var a = new Date();
      var b = a.setDate(a.getDate() - 30);
      return b;
    },
  },
  components: {
    Datepicker,
    'v-select': vSelect,
  },
};
</script>

<style>
#DateLabel {
  font-size: 1em;
  color: rgb(77, 77, 77);
  margin-left: 0.5em;
}

.vdp-datepicker input {
  width: 100%;
}

.vdp-datepicker__calendar {
  z-index: 900 !important;
}
</style>
